
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComMicrophone as ObiComMicrophoneElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-microphone.js';
 
 
 

 
 export const ObiComMicrophone = createComponent({
   react: React,
   tagName: 'obi-com-microphone',
   elementClass: ObiComMicrophoneElement,
   events: {
     
   }
  });
 
 